var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft2Lengeh2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 30",
    style: {
      enableBackground: "new 0 0 59 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4,15.2H7.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.7c0.3,0,0.5,0.2,0.5,0.5S17.7,15.2,17.4,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.7,9.8 16.7,19.6 21.6,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4,15.2h-9.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.7c0.3,0,0.5,0.2,0.5,0.5S50.7,15.2,50.4,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.4,19.6 41.4,9.8 36.5,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H0V0h59V30z M1,29h57V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7,26H4V3.7h21.8V26z M4.9,25h19.8V4.7H4.9V25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30h-30V0h30V30z M29.8,29h28.1V1H29.8V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,27.3H29.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h28.8c0.3,0,0.5,0.2,0.5,0.5S58.3,27.3,58.1,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,4.1H29.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h28.8c0.3,0,0.5,0.2,0.5,0.5S58.3,4.1,58.1,4.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft2Lengeh2);
export default __webpack_public_path__ + "static/media/joft_2_lengeh_2.d5e6f1adb913c9c0fdc4f24702ab4fb3.svg";
export { ForwardRef as ReactComponent };